'use client';

import type { FC, HTMLAttributes } from 'react';
import { Button, useToast } from '@paypoteam/ui-components';

import { promoCodeCopyEvent } from '@/lib/gtm';
import { cn } from '@/lib/utils';

import { Title } from '@/components/atoms/Typography/Title';
import type { PromoCodeButtonType } from '@/components/templates/IconPointerListContent/IconPointerListContent.types';

export interface PromoCodeProps extends HTMLAttributes<HTMLDivElement> {
    promoCodeText: string;
    promoCode: string;
    buttonConfig: PromoCodeButtonType;
}

const PromoCode: FC<PromoCodeProps> = ({
    promoCodeText,
    promoCode,
    buttonConfig,
    className,
}) => (
    <div
        className={cn(
            'flex flex-col items-center gap-6 md:flex-row',
            className,
        )}
    >
        <div className="flex flex-wrap items-center justify-center gap-2">
            <Title
                size="l"
                className="text-typo-secondary"
            >
                {promoCodeText}
            </Title>

            <Title size="l">{promoCode}</Title>
        </div>

        <Button
            size="m"
            onClick={() => {
                useToast({
                    duration: 5000,
                    hasCloseIcon: true,
                    title: 'Skopiowano kod promocyjny.',
                    variant: 'success',
                });

                navigator.clipboard.writeText(buttonConfig.value);
                promoCodeCopyEvent(promoCode);
            }}
            className={buttonConfig.className}
        >
            {buttonConfig.text}
        </Button>
    </div>
);

export default PromoCode;
